import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppPrivileges from "@/components/privileges/appPrivileges/AppPrivileges";

const AppPrivilegesPage = () => {
  const { appId } = useParams();
  const [applicationName, setApplicationName] = useState<string>("");

  const handleApplicationLoaded = (name: string) => {
    setApplicationName(name);
  };

  return (
    <>
      <AppPrivileges
        ApplicationId={Number(appId)}
        ShowOnlyNewAppPrivilegePanel={false}
        onApplicationLoaded={handleApplicationLoaded}
        breadcrumbTitle="Application | Privileges"
        breadcrumbSubtitle={
          applicationName ? (
            <>
              Manage privileges for application{" "}
              <strong>{applicationName}</strong>
            </>
          ) : (
            "Manage privileges for this application"
          )
        }
      />
    </>
  );
};

export default AppPrivilegesPage;
